import { cliSimpleGit } from '../cli-simple-git.js';

/** Force checkout and clean a worktree to match a local branch tip. */
export async function gitResetWorktreeToBranch(worktreePath: string, branch: string): Promise<void> {
  const git = cliSimpleGit(worktreePath);
  await git.checkout(['-f', branch]);
  await git.reset(['--hard', branch]);
  await git.clean('fd');
}
